export default "__VITE_ASSET__BL4pk1Fr__"